function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useMemo, useRef, useState } from 'react';
import { classnames, getScrollBarWidth } from '@okee-uikit/react-utils';
import { useConst } from '@okee-uikit/react-hooks';
import { usePrefixCls, useDirection } from '@okee-uikit/react-config';
import { TableProvider, useCreateTable } from '../../hooks/table';
import { Loading } from '../loading';
import { TableBody } from './TableBody';
import { TableHead } from './TableHead';
import { TableRow } from './TableRow';
import { TableRowGroup } from './TableRowGroup';
import { TableScrollerBar, TableScrollBarContext } from './TableScrollerBar';
import { TableTheme } from './context/theme';
export function PureTable(props) {
  var rowKey = props.rowKey,
      _props$minimalNonFixe = props.minimalNonFixedWidth,
      minimalNonFixedWidth = _props$minimalNonFixe === void 0 ? 0 : _props$minimalNonFixe,
      columns = props.columns,
      _props$bordered = props.bordered,
      bordered = _props$bordered === void 0 ? false : _props$bordered,
      _props$stripe = props.stripe,
      stripe = _props$stripe === void 0 ? false : _props$stripe,
      _props$rowBordered = props.rowBordered,
      rowBordered = _props$rowBordered === void 0 ? !stripe : _props$rowBordered,
      _props$innerBordered = props.innerBordered,
      innerBordered = _props$innerBordered === void 0 ? false : _props$innerBordered,
      _props$outerBordered = props.outerBordered,
      outerBordered = _props$outerBordered === void 0 ? false : _props$outerBordered,
      _props$loading = props.loading,
      loading = _props$loading === void 0 ? false : _props$loading,
      loadingZIndex = props.loadingZIndex,
      children = props.children,
      className = props.className,
      style = props.style,
      size = props.size,
      rowHeight = props.rowHeight,
      headRowHeight = props.headRowHeight,
      headGroupHeight = props.headGroupHeight,
      fixedScrollBar = props.fixedScrollBar;
  var rtl = useDirection() === 'rtl';
  var ref = useRef(null);
  var table = useCreateTable(ref, {
    minimalNonFixedWidth: minimalNonFixedWidth,
    columns: columns,
    rowKey: rowKey
  });
  var manager = table.getLeafColumnManager();

  var _useState = useState(function () {
    var sizeInfo = manager.getColumnSizeInfo();
    return {
      tableWidth: sizeInfo.tableWidth,
      scrollWidth: sizeInfo.fixedLeftWidth + sizeInfo.fixedRightWidth + sizeInfo.scrollerWidth,
      scroll: manager.getColumnScrollInfo().scroll
    };
  }),
      _useState2 = _slicedToArray(_useState, 2),
      _useState2$ = _useState2[0],
      tableWidth = _useState2$.tableWidth,
      scrollWidth = _useState2$.scrollWidth,
      setInfo = _useState2[1];

  var scrollBarContext = useConst({
    setInfo: setInfo
  });

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      scrollBarWidth = _useState4[0],
      setScrollBarWidth = _useState4[1];

  useEffect(function () {
    setScrollBarWidth(getScrollBarWidth());
  }, []);
  var cls = classnames(usePrefixCls('table', {
    rtl: rtl
  }), className);
  var innerCls = usePrefixCls('table-container', {
    stripe: stripe,
    inner: bordered || innerBordered,
    outer: bordered || outerBordered,
    row: bordered || rowBordered
  });
  var scrollerCls = usePrefixCls('table-scroller');
  var scrollerStyle = useMemo(function () {
    return {
      paddingBottom: fixedScrollBar && scrollWidth > tableWidth ? "".concat(scrollBarWidth, "px") : undefined
    };
  }, [fixedScrollBar, tableWidth, scrollWidth, scrollBarWidth]);
  var theme = useMemo(function () {
    return {
      size: size,
      rowHeight: rowHeight,
      headRowHeight: headRowHeight,
      headGroupHeight: headGroupHeight
    };
  }, [size, rowHeight, headRowHeight, headGroupHeight]);
  var inner = React.createElement("div", {
    className: innerCls
  }, React.createElement("div", {
    className: scrollerCls,
    ref: ref,
    style: scrollerStyle
  }, children));
  return React.createElement(TableProvider, {
    value: table
  }, React.createElement(TableTheme.Provider, {
    value: theme
  }, React.createElement(TableScrollBarContext.Provider, {
    value: scrollBarContext
  }, React.createElement("div", {
    className: cls,
    style: style
  }, React.createElement(Loading.BlockLoading, {
    show: loading,
    maskStyle: {
      backgroundColor: 'rgba(255, 255, 255, .7)'
    },
    zIndex: loadingZIndex
  }, inner)))));
}
PureTable.Head = TableHead;
PureTable.Body = TableBody;
PureTable.Row = TableRow;
PureTable.RowGroup = TableRowGroup;
PureTable.ScrollerBar = TableScrollerBar;